import { useStore } from '@/util/vuex'
import { TYPE } from 'vue-toastification'

export function useToast() {
    const store = useStore()

    const showToast = (message, options = {}) => {
        store.dispatch('showToast', {
            message,
            options,
        })
    }

    const showSuccessToast = (message, options = {}) => {
        store.dispatch('showToast', {
            message,
            options: {
                ...options,
                type: TYPE.SUCCESS,
            },
        })
    }

    const showErrorToast = (message, options = {}) => {
        store.dispatch('showToast', {
            message,
            options: { ...options, type: TYPE.ERROR },
        })
    }

    const showInfoToast = (message, options = {}) => {
        store.dispatch('showToast', {
            message,
            options: { ...options, type: TYPE.INFO },
        })
    }

    return {
        showToast,
        showSuccessToast,
        showErrorToast,
        showInfoToast,
    }
}
